<template>
  <div class="header mt-0">
    <div class="row options">
      <div id="radios">
        <label for="month-date" class="material-icons" @click="setTimeFrame(2)">
          <input type="radio" name="mode" id="month-date" value="month" :checked="activeTab===2" />
          <span>THIS MONTH</span>
        </label>
        <label for="driving" class="material-icons" @click="setTimeFrame(7)">
          <input type="radio" name="mode" id="driving" value="yesterday" :checked="activeTab===7" />
          <span>YESTERDAY</span>
        </label>
        <label for="cycling" class="material-icons" @click="setTimeFrame(4)">
          <input type="radio" name="mode" id="cycling" value="today" :checked="activeTab===4"/>
          <span>TODAY</span>
        </label>

        <label for="strapping" class="material-icons" @click="$store.commit('setActiveTab',5)">
          <input type="radio" name="mode" id="strapping" value="advanced" :checked="activeTab===5"/>
          <span>ADVANCED</span>
        </label>
      </div>
      <div class="row float-end mx-2">
        <div v-if="activeTab === 5">
          <label>
            Start Date
            <input type="date" class="form-control" required v-model="range.from">
          </label>

          <label class="m-3">
            End Date
            <input type="date" class="form-control" required v-model="range.to">
          </label>
          <button type="submit" class="btn btn-primary" @click="setTimeFrame(5)">Select</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TimeManager from "@/services/TimeManager";

export default {
  name: "DateRangeSelector",
  data() {
    return {
      dateTimeManager: TimeManager,
      range: this.$store.getters.getGlobalDateRange
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters.getActiveTab;
    },
  },
  props: {
    submitMethod: {type: Function, required: true},
  },
  methods: {
    setTimeFrame(type = 2) {
      this.$utils.showLoading()
      this.$store.commit('setActiveTab', type);
      switch (type) {
        case 1:
          this.$store.commit('setGlobalDateRange', this.dateTimeManager.getThisYear())
          break;

        case 2:
          this.$store.commit('setGlobalDateRange', this.dateTimeManager.getThisMonth())
          break;

        case 4:
          this.$store.commit('setGlobalDateRange', this.dateTimeManager.getToday())
          break;

        case 5:
          if (!this.range.from || !this.range.to) {
            return responses.showWarning(`Invalid Time Frame`)
          }
          this.$store.commit('setGlobalDateRange', this.range)
          break;

        case 7:
          this.$store.commit('setGlobalDateRange', this.dateTimeManager.getYesterday())
          break;
      }
      return Promise.all([
        this.submitMethod()
      ]).finally(() => this.$utils.hideLoading());
    },
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;


  p {
    color: #fff;
    font-size: 1.5em;
  }

  #myChart {
    height: 100% !important;
  }

  .scrollmenu {
    z-index: 9999;
    display: flex;
    justify-content: center;

    a {
      color: #ffffff !important;
    }
  }

  .chart {
    position: absolute;
    top: 45px;
    left: 10px;
    right: 10px;
    bottom: 35px;
    padding-top: 17px;
  }

  #radios {
    text-align: center;
    margin: 0 auto;
    z-index: 9999;

    #radios label {
      cursor: pointer;
      position: relative;
    }

    #radios label + label {
      margin-left: 15px;
    }

    input[type="radio"] {
      opacity: 0; /* hidden but still tabable */
      position: absolute;
    }

    input[type="radio"] + span {
      color: #B3CEFB;
      border-radius: 17px;
      padding: 5px 10px;
      transition: all 0.4s;
      -webkit-transition: all 0.4s;
    }

    input[type="radio"]:checked + span {
      color: #D9E7FD;
      background-color: rgba(24, 110, 218, 0.5);
      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      border-radius: 18px;
    }

    input[type="radio"]:focus + span {
      color: #fff;
    }
  }
}

.options {
  padding-top: 20px;
  padding-bottom: 30px;
}
</style>

